import { getDownloadURL, getMetadata, getStorage, listAll, ref } from 'firebase/storage';

// Listing, file URLs and metadata are required. Propagate failures so callers
// cannot mistake denied access for an empty folder or bypass metadata filters.
export default async function getKycFiles(path: string) {
    const storage = getStorage();
    const { items } = await listAll(ref(storage, path));

    return Promise.all(items.map(async (item) => {
        const thumbRef = ref(storage, `${path}thumbnails/${item.name.replace(/\.pdf$/i, '.png')}`);
        const [link, metadata, thumb] = await Promise.all([
            getDownloadURL(item),
            getMetadata(item),
            // Thumbnails may still be generating; the original file remains usable.
            getDownloadURL(thumbRef).catch(() => null),
        ]);

        return {
            name: item.name,
            link,
            thumb,
            ref: item,
            metadata,
            metadataName: Object.keys(metadata.customMetadata ?? {}),
            created: new Date(metadata.timeCreated),
            thumbRef,
        };
    }));
}
